import React, { useState } from 'react';
import FindPlayers from './FindPlayers';
import { Accordion, AccordionSummary, AccordionDetails } from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

export default function MetaDB() {
    const [selectedPlayer, setSelectedPlayer] = useState({});
    const [playerId, setPlayerId] = useState();
    const [idType, setIdType] = useState("FIDE");

    return (
        <div>
            <Accordion m={2} pt={3} pl={0} pr={0} defaultExpanded={true}>
                <AccordionSummary aria-controls="event-info" id="event-info" expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: '#1976d2' }}>
                    <Typography color='white'>Search MetaDB - Games are imported hourly!</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <FindPlayers sendToParentIdType={setIdType} sendToParentPlayerId={setPlayerId} sendToParentSelectedPlayer={setSelectedPlayer} />
                </AccordionDetails>
            </Accordion>
            
        </div>
        )
}
